'use client';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@ui/dropdown-menu';
import { useMatchScreen } from 'hooks/use-match-screen';
import { MenuIcon } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { Fragment, useState, useEffect } from 'react';
import styles from './mobile-navigation.module.scss';
import { AuthButtons } from '../auth-buttons';
import { ROUTES } from '../routes.const';

export const MobileNavigation = () => {
  const { isMobile } = useMatchScreen();

  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!isMobile || !mounted) return null;

  const onLinkClick = () => setIsOpen(false);

  return (
    <div className={styles.burger}>
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger>
          <MenuIcon />
        </DropdownMenuTrigger>
        <DropdownMenuContent className={styles.burgerDropdown}>
          <div className={styles.logo}>
            <Image
              alt="logo"
              height="32"
              width="105"
              src="/images/codesi_logo_full.svg"
            />
          </div>
          <DropdownMenuSeparator />

          {ROUTES.map((route, index: number) => {
            if (route.nested) {
              return (
                <Fragment key={route.path}>
                  <DropdownMenuLabel className={styles.burgerLabel}>
                    {route.title}
                  </DropdownMenuLabel>

                  {route.nested.map((nestedRoute) => (
                    <DropdownMenuLabel
                      key={nestedRoute.path}
                      className={styles.burgerNestedLabel}
                      asChild
                    >
                      <Link href={nestedRoute.path} onClick={onLinkClick}>
                        {nestedRoute.title}
                      </Link>
                    </DropdownMenuLabel>
                  ))}

                  {ROUTES.length - 1 !== index && <DropdownMenuSeparator />}
                </Fragment>
              );
            }

            return (
              <Fragment key={route.path}>
                <DropdownMenuLabel className={styles.burgerLabel} asChild>
                  <Link href={route.path} onClick={onLinkClick}>
                    {route.title}
                  </Link>
                </DropdownMenuLabel>
                {ROUTES.length - 1 !== index && <DropdownMenuSeparator />}
              </Fragment>
            );
          })}

          <DropdownMenuSeparator />
          <div className={styles.burgerActions}>
            <AuthButtons />
          </div>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
